import { useFormik } from 'formik';
import { Button, Dialog, Dropdown, InputText, classNames } from 'primereact'
import React, { useEffect, useState } from 'react'

import {toastShow} from '../../../../Base/Services/ToastService'
import {  getMenus } from '../../../../Base/API/Menu/MenuRequests';
import Loader from '../../../../Base/Components/Loader/Loader';
import { IUAccesoWebUser } from '../../../../API/IT/Accesos/AccesosRequests';

const AccesosCrud = ({ accesosDialog, setAccesosDialog, datos, toast, getAccesos }) => {

    console.log({datos});

    const inicioValores = {
        IdAcceso: -199,
        Acceso: "",
        ActivoWeb: true,
        ActivoApp: true,
        IdMenu: 0,
        Menu: '',
        IdMenuMenu: 0,
        Icon: '',
        URL: ''
    }

    const [formData, setFormData] = useState({});
    const [menu, setMenu] = useState([]);
    const [loading, setLoading] = useState(false);

    const hideDialog = () => {
        setAccesosDialog(false);
    }

    const activoWeb = [
        {
            Id: true,
            Estado: "Activo"
        },
        {
            Id: false,
            Estado: "Inactivo"
        },

    ]

    const agregarAcceso = async (data) => {
        const resultado = await IUAccesoWebUser(data);
        if (resultado) {
            toastShow(toast, 'success', 'Creado', 'Informacion ingresada Correctamente.');
            setFormData({});
            formik.resetForm(formData);
            getAccesos();
            hideDialog();
            return true;
        }else{
            toastShow(toast, 'error', 'Error', 'Error al editar la informacion');
            return false;
        }
    }


    const formik = useFormik({
        initialValues:  datos ? datos : inicioValores,
        validate: (data) => {
            let errors = {};

            if (!data.Acceso) {
                errors.Acceso = 'Se requiere el nombre del acceso.';
            }
            if (!data.IdMenu) {
                errors.IdMenu = 'Se requiere el nombre del acceso.';
            }
            if (data.ActivoWeb === null) {
                errors.ActivoWeb = 'Se requiere el estado del acceso.';
            }
            if (!data.ActivoApp === null) {
                errors.ActivoApp = 'Se requiere el estado del acceso.';
            }

            return errors;
        },

        onSubmit: async (data) => {
            setFormData(data);
            await agregarAcceso(data)

        }
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);

    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };


    const getInfo = async () => {
        setLoading(true)
        const result = await getMenus();
        setMenu(result);
        setLoading(false);
    }



    useEffect(() => {
        getInfo();
    }, [accesosDialog])

    return (
        <div>
            <Dialog visible={accesosDialog} breakpoints={{ '960px': '75vw', '640px': '100vw' }} style={{ width: '30vw' }}
                onHide={hideDialog} header={<h2>Acceso</h2>}>
                <div id='modalEditAccesos' style={{ width: '100%', margin: 'auto' }}>
                    <Loader loading={loading} querySelector={'#modalEditAccesos'} />
                    <form onSubmit={formik.handleSubmit} className="p-fluid" style={{ margin: "Auto", marginBottom: 0 }}>
                        <div className="modal__input-contenedor" style={{ width: "100%" }}>
                            <div className="field col-6 me-2" style={{ marginTop: 26 }} >
                                <span className="p-float-label">
                                    <InputText id="Acceso" name="Acceso" value={formik.values?.Acceso} onChange={formik.handleChange} autoFocus
                                        className={classNames({ 'p-invalid': isFormFieldValid('Acceso') })} autoComplete="off" />
                                    <label htmlFor="Acceso" className={classNames({ 'p-error': isFormFieldValid('Acceso') })}>Nombre del Acceso</label>
                                </span>
                                {getFormErrorMessage('Acceso')}
                            </div>
                            <div className="field col-6 me-2" >
                                <label htmlFor="dropdown">Menu</label>
                                <Dropdown id="IdMenu" name="IdMenu" value={formik.values?.IdMenu} onChange={formik.handleChange} options={menu} optionLabel="Menu"
                                    optionValue="IdMenu" />
                                {getFormErrorMessage('IdMenu')}
                            </div>
                        </div>
                        <div className="modal__input-contenedor" style={{ width: "100%" }}>
                            <div className="field col-6 me-2" >
                                <label htmlFor="dropdown">Activo Web</label>
                                <Dropdown id="ActivoWeb" name="ActivoWeb" value={formik.values.ActivoWeb} onChange={formik.handleChange} options={activoWeb} optionLabel="Estado"
                                    optionValue="Id" />
                                {getFormErrorMessage('ActivoWeb')}
                            </div>
                            <div className="field col-6 me-2" >
                                <label htmlFor="dropdown">Activo App</label>
                                <Dropdown id="ActivoApp" name="ActivoApp" value={formik.values.ActivoApp} onChange={formik.handleChange} options={activoWeb} optionLabel="Estado"
                                    optionValue="Id" />
                                {getFormErrorMessage('ActivoApp')}
                            </div>

                        </div>
                        <div className="p-dialog-footer">
                            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
                            <Button type='submit' label="Guardar" icon="pi pi-check" className="p-button-text" />
                        </div>
                    </form>
                </div>
            </Dialog>
        </div>
    )
}

export default AccesosCrud